/*
 * Design: Gradient Noir – Floating WhatsApp button
 * Fixed bottom-left (RTL layout), with pulse animation, hover tooltip, and smooth entrance
 */
import { useState, useEffect } from "react";

const WHATSAPP_NUMBER = "972542950091";
const WHATSAPP_MESSAGE = "שלום, אשמח לשמוע פרטים נוספים על השירותים שלכם";

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    // Delay entrance so it doesn't compete with page load
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div
      className="fixed bottom-6 left-6 z-50 flex items-end gap-3 transition-all duration-700"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.8)",
      }}
    >
      {/* Tooltip */}
      <div
        className="transition-all duration-300 origin-bottom-left"
        style={{
          opacity: hovered ? 1 : 0,
          transform: hovered ? "translateX(0) scale(1)" : "translateX(-8px) scale(0.95)",
          pointerEvents: hovered ? "auto" : "none",
        }}
      >
        <div className="bg-white text-[#0F172A] text-sm font-semibold px-4 py-2.5 rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.3)] whitespace-nowrap mb-1">
          דברו איתנו בוואטסאפ
          <div className="absolute -bottom-1 left-5 w-2.5 h-2.5 bg-white rotate-45 rounded-sm" />
        </div>
      </div>

      {/* Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="relative group flex items-center justify-center w-[60px] h-[60px] rounded-full bg-[#25D366] shadow-[0_6px_24px_rgba(37,211,102,0.4)] hover:shadow-[0_8px_32px_rgba(37,211,102,0.55)] hover:scale-110 active:scale-95 transition-all duration-300"
        aria-label="שלחו הודעה בוואטסאפ"
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-wa-pulse" />

        {/* WhatsApp SVG icon */}
        <svg
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 h-8 relative z-10"
        >
          <path
            d="M16.004 2.667A13.28 13.28 0 0 0 2.72 15.947a13.18 13.18 0 0 0 1.787 6.627L2.667 29.333l6.96-1.82A13.28 13.28 0 0 0 16.004 29.333 13.28 13.28 0 0 0 29.333 16.053 13.28 13.28 0 0 0 16.004 2.667Zm0 24.266a10.88 10.88 0 0 1-5.547-1.52l-.4-.24-4.12 1.08 1.1-4.013-.26-.413a10.84 10.84 0 0 1-1.667-5.787 10.88 10.88 0 0 1 10.894-10.88 10.88 10.88 0 0 1 10.893 10.88 10.88 10.88 0 0 1-10.893 10.893Zm5.973-8.147c-.327-.167-1.94-.96-2.24-1.067-.3-.113-.52-.167-.74.167-.22.333-.847 1.067-1.04 1.287-.193.22-.387.247-.713.08-.327-.167-1.38-.507-2.627-1.62-.973-.867-1.627-1.94-1.82-2.267-.193-.327-.02-.5.147-.667.147-.147.327-.387.493-.58.167-.193.22-.333.333-.553.113-.22.06-.413-.033-.58-.087-.167-.74-1.787-1.013-2.447-.267-.64-.54-.553-.74-.567h-.633c-.22 0-.58.08-.88.413-.3.333-1.153 1.127-1.153 2.747s1.18 3.187 1.347 3.407c.167.22 2.327 3.553 5.64 4.98.787.34 1.4.54 1.88.693.793.253 1.513.22 2.08.133.633-.093 1.94-.793 2.213-1.56.273-.767.273-1.42.193-1.56-.08-.14-.3-.22-.627-.387Z"
            fill="white"
          />
        </svg>
      </a>
    </div>
  );
}
